import { render, staticRenderFns } from "./404.html.vue?vue&type=template&id=69fc0e87"
import script from "./404.html.vue?vue&type=script&lang=js"
export * from "./404.html.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports